import { TAdvQuery,TAdvQueryErrors } from '@/utils/ZAdvQuery.js';
import { TZMathFunct } from '@/utils/ZMathFunct.js'
import axios from 'axios';

export const NUMERO_VERSIONE_DMSEW = '1.16.97'                                 
const NUMERO_GIORNI_DIVISIONE_CHIAMATA_DATI_STORICI = 30 * 24 * 60 * 60 * 1000 // 60 giorni

export const SOGLIE_GRAFICI_VELOCITA = [ 0.59, 1.83, 4.30 ];

export const ID_PAGINE = 
{
   DASHBOARD                              : 1,
   CONFIGURAZIONI                         : 2,

   AMMINISTRAZIONE                        : 3,
   AMM_GESTIONE                           : 4,
   AMM_GESTIONE_UTENTI                    : 5,
   AMM_GESTIONE_MESSAGGI                  : 6,

   CFG_SITI                               : 7,

   VERSIONE                               : 8,
   VERTICALI                              : 9,
   ADD_MESSAGGIO                          : 10,
   SCHEDA_MESSAGGI                        : 11,
   ESPORTAZIONE_XLSX                      : 12,
   MODIFICA_SITI                          : 13,
   STORICI                                : 14,

   POPUP_CAMPIONI_RILEVATI                : 15,
   POPUP_SPOSTAMENTO_GRAF_SEPARATI        : 16,
   POPUP_SPOSTAMENTO_GRAF_SOVR            : 17,
   POPUP_VELOCITA_MEDIA_ORARIA            : 18,
   POPUP_VELOCITA_MEDIA_GIORNALIERA       : 19,
   POPUP_ACCELERAZIONE_MEDIA_ORARIA       : 20,
   POPUP_ACCELERAZIONE_MEDIA_GIORNALIERA  : 21,

   POPUP_EVENTI_ACCELEROMETRICI_A         : 22,
   POPUP_EVENTI_ACCELEROMETRICI_F         : 23,
   POPUP_EVENTI_ACCELEROMETRICI_SS        : 24,
   POPUP_EVENTI_ACCELEROMETRICI_CE        : 25,

   POPUP_TENSIONE_ALIMENTAZIONE           : 26,
   POPUP_ASSORBIMENTO                     : 27,
   POPUP_STAZIONE_METEO                   : 28,

   RIASSUNTO_ACCELEROMETRI                : 29,

   POPUP_ALLINEAMENTO_ASSE_X              : 30,
   POPUP_ALLINEAMENTO_ASSE_Y              : 31,
   POPUP_ALLINEAMENTO_ASSE_TEMP           : 32,

   VERTICALI_MODULABILI                   : 33,
   MODULAZIONE_GRAFICI                    : 34,
   ADATTA_GRAFICI                         : 35,
   ESPORTA_PDF                            : 36,
   SPOST_DIFFERENZIALE                    : 37,
   MEDIA_ARITMETICA                       : 38,
   CAMBIA_SCALE                           : 39,
   MASSIMIZZA                             : 40,
   ESPORTA_XLSX_CAMPIONI_RILEVATI         : 41,
   ESPORTA_XLSX_SPOSTAMENTI               : 42,

   MENU_ALLARMI                           : 43,

   MOSTRA_NASCONDI_ALLARMI                : 44,
   PROGETTO                               : 45,
   MOSTRA_GRAFICI                         : 46,
   ALLINEA_POLARI                         : 47,
   AGGIUNGI_ABBINATO                      : 48,
   MENU_CATENE                            : 49,
   ABILITA_SPOSTAMENTO                    : 50,

   POPUP_IMPOSTA_ALLARMI                  : 51,
   
   POPUP_ALLINEAMENTO_ASSE_INCLINOMETRI   : 52,
   POPUP_ALLINEAMENTO_ASSE_PIEZOMETRI     : 53,
   POPUP_ALLINEAMENTO_ASSE_ESTENSIMETRI   : 54,

   POPUP_SCALA_X                          : 55,
   POPUP_SCALA_Y                          : 56,
   POPUP_COLORE_AMPIEZZA_ASSE_X           : 57,
   POPUP_COLORE_AMPIEZZA_ASSE_Y           : 58,
   POPUP_COLORE_AMPIEZZA_ASSE_Z           : 59,
   AGGIUNGI_RIGHELLO_ACCELEROMETRI        : 60,
   ELIMINA_RIGHELLO_ACCELEROMETRI         : 61,
   POPUP_COLORE_FREQUENZA                 : 62,

   POPUP_SCALA_GRAPH_X                    : 63,
   POPUP_SCALA_GRAPH_Y                    : 64,
   POPUP_SCALA_GRAPH_Z                    : 65,

   MOSTRA_SOGLIE_RILEVAMENTO              : 66,
   NASCONDI_SOGLIE_RILEVAMENTO            : 67,

   AGGIORNA_LINGUE                        : 98,
   TORNA_ALLA_CATENA                      : 99,
}

export const TIPO_ELEMENTO_PDF = {
                                    ELEMENTO_STORICO      : 0,
                                    ELEMENTO_ATTUALE      : 1,
                                    ELEMENTO_INTESTAZIONE : 2,
                                    ELEMENTO_SOMMARIO     : 3,
                                    ELEMENTO_VERTICALE    : 4,
                                    ELEMENTO_ORIZZONTALE  : 5,
                                    PRIMA_PAGINA          : 6,
                                 }

export const TIPOLOGIA_GRAFICI_STORICI =  {
                                            CAMPIONI_RILEVATI                      : 0,
                                            SPOSTAMENTI_GRAFICI_SEPARATI           : 1,
                                            SPOSTAMENTI_GRAFICI_SOVR               : 2,
                                            VELOCITA_MEDIA_ORARIA                  : 3,
                                            VELOCITA_MEDIA_GIORNALIERA             : 4,
                                            ACCELERAZIONE_MEDIA_ORARIA             : 5,
                                            ACCELERAZIONE_MEDIA_GIORNALIERA        : 6,

                                            EV_ACCELEROMETRICI_SINTETICI_A         : 7,
                                            EV_ACCELEROMETRICI_SINTETICI_F         : 8,
                                            EV_ACCELEROMETRICI_SUP_SOGLIE          : 9,
                                            EV_ACCELEROMETRICI_CRONOLOGIA          : 10,

                                            TENSIONE_ALIMENTAZIONE                 : 11,
                                            ASSORBIMENTO                           : 12,
                                            STAZIONE_METEO                         : 13,
                                            GRAFICI_GV                             : 14,
                                          }
                              
export const COLORI_PANTONE = {
                                Arancione : '#F18B53', //'#ff734d',
                                Marrone   : '#7B6A58',  //'#60604d'
                                Bianco    : '#fff'
                              }
                              
export const SFONDO         = {
                                Arancione : '#fabe98',
                                Marrone   : '#968c7a'
                              }

export const COLORI_PRIORITA = ['red', 'orange', 'yellow', 'green', 'white']

export const COLORI_ALLARME = ['yellow', 'orange', 'red', 'purple']

export const COLORI_FALDE = ['#0040ff','#0080ff','#00ffff']

export const SPESSORE_LINEE_GRAFICI = 2

export const COLORI_DEFAULT_GRAFICI = [ '#00FFFF', 
                                        '#0000FF', 
                                        '#FF0000', 
                                        '#008000', 
                                        '#00FF00', 
                                        '#FF8040', 
                                        '#FF0080', 
                                        '#800040', 
                                        '#FF80FF', 
                                        '#808080', 
                                        '#408080', 
                                        '#808040', 
                                        '#0080FF', 
                                        '#400080', 
                                        '#800000' 
                                      ]

export const DIM_CENTRO_GRAPH = 30

export const GIORNI_CARICA_GV = 31

export const IMMAGINE_SITO_DEFAULT   = /*'data:image/jpeg;/Default/DefaultImgSito.jpg'*/ require('@/assets/images/DefaultImgSito.jpg')

export const MAX_ZOOM = 10

export const LOCALSTORAGE = { 
                              TokenRememberMe : "DMSEWTokenRememberMe",
                              OggettoInfoGraficiStorici : "DMSEWOggettoInfoGraficiStorici",
                              LanguageDMSEW : "LanguageDMSEW",
                              GraficiAbbinatiAllineati : "DMSEWGraficiAbbinatiAllineati"
                            }  

export const TIPO_FILE = {
                          FileImmagine   : 'I',
                          FilePdf        : 'P',
                          FileAltro      : 'A'
                         }

export const RUOLI = {
                        Amministratore : 'A',
                        SuperUtente    : 'S',
                        Supervisore    : 'M',
                        Utente         : 'U'       
                     }

export const COLORI = {
                        Verde  : '#74b83d',
                        Giallo : '#f5bb00',
                        Rosso  : '#de3214'
                      }

export const GRANDEZZE_ALLARME =  {
                                    TEMP     : 'Termometro',
                                    PRES     : 'Piezometro',
                                    PRES2    : 'Piezometro 2',
                                    EST      : 'Estensimetro',
                                    EST2     : 'Estensimetro 2',
                                    PITCH1   : 'Pitch 1',
                                    ROLL1    : 'Roll 1',
                                    YAW1     : 'Yaw 1',
                                    MOD1     : 'Modulo 1',
                                    PITCH2   : 'Pitch 2',
                                    ROLL2    : 'Roll 2',
                                    YAW2     : 'Yaw 2',
                                    MOD2     : 'Modulo 2',
                                    XTILT    : 'XTilt',
                                    YTILT    : 'YTilt',
                                    ZTILT    : 'ZTilt',
                                    MOD335   : 'Mod. 335',
                                    ExtraBlackout : 'Blackout'
                                  }

export const PRETTY_GRANDEZZE_ALLARME = {
                                          TEMP     : 'Termometro',
                                          PRES     : 'Piezometro',
                                          PRES2    : 'Piezometro',
                                          EST      : 'Estensimetro',
                                          EST2     : 'Estensimetro',
                                          PITCH1   : 'Pitch',
                                          ROLL1    : 'Roll',
                                          YAW1     : 'Yaw',
                                          MOD1     : 'Modulo',
                                          PITCH2   : 'Pitch',
                                          ROLL2    : 'Roll',
                                          YAW2     : 'Yaw',
                                          MOD2     : 'Modulo',
                                          XTILT    : 'XTilt',
                                          YTILT    : 'YTilt',
                                          ZTILT    : 'ZTilt',
                                          MOD335   : 'Mod. 335',
                                          ExtraBlackout : 'Blackout'
                                        }

export const TIPI_ALLARME      =  {
                                    A : 'Assoluto',
                                    G : 'Giornaliero',
                                    O : 'Orario',
                                    ExtraBlackout : '-'
                                  }

export const LINGUA_DEFAULT = 'Inglese';

/**
 * Colonna TIPOLOGIA (storico_allarmi) → chiave UI usata in TipiAllarmiAttivi.
 */
export const TIPOLOGIA_ALLARME_TO_UI = {
                                        temperatura    : 'Termometro',
                                        piezometro     : 'Pressione',
                                        estensimetro   : 'Estensimetro',
                                        inclinometrico : 'Inclinometro',
                                        sghembo        : 'Sghembo',
                                        accelerometrico: 'Accelerometro'
                                      }

/**
 * Chiavi UI dei tipi allarme (CFG / TipiAllarmiAttivi).
 * La classificazione avviene su TIPOLOGIA via TIPOLOGIA_ALLARME_TO_UI.
 */
export const TIPI_GRANDEZZE_ALLARME = {
                                        Termometro    : true,
                                        Pressione     : true,
                                        Estensimetro  : true,
                                        Inclinometro  : true,
                                        Sghembo       : true,
                                        Accelerometro : true
                                      }

export const TIPI_GRAFICI = {
                              // Verticali
                              Polare       : 0,
                              SpostEst     : 1,
                              SpostNord    : 2,
                              SpostTot     : 3,
                              SpostAzimuth : 4,
                              Temperatura  : 5,
                              Deformazione : 6,
                              Piezometro   : 7,
                              // Orizzontali
                              TemperaturaO     : 8,
                              ProfiloLong      : 9,
                              DeformazioneO    : 10,
                              ProfiloLongAll   : 11,
                              DeformazioneOAll : 12,
                            }

export const TIPI_MODULI = {
                              Polare         : 1,
                              SpostEst       : 2,
                              SpostNord      : 3,
                              SpostTot       : 4,
                              SpostAzimuth   : 5,
                              Temperatura    : 6,
                              Deformazione   : 7,
                              Piezometro     : 8,

                              InfoGenerali   : 9,
                              Abbinati       : 10,
                              Allineamento   : 11,
                              Immagine       : 12,
                              Spacer         : 13,

                              CampRilevati   : 14,
                              Spostamenti    : 15,
                              Velocità       : 16,
                              Accelerazione  : 17,
                              Assorbimento   : 18,
                              TensAlim       : 19,
                              
                              MontaggioGV    : 20, 
                              
                              EvAccAmpiezza  : 21,
                              EvAccFrequenza : 22,
                              TemperaturaO   : 23,
                              ProfiloLong    : 24,
                              DeformazioneO  : 25,  
                              ProfiloLongAll : 26,
                              DeformazioneOAll : 27,
                            }

export const GRAFICI_ATTUALI_TERZO_ASSE = [
                                            TIPI_GRAFICI.ProfiloLong,
                                            TIPI_GRAFICI.DeformazioneO,
                                            TIPI_GRAFICI.ProfiloLongAll,
                                            TIPI_GRAFICI.DeformazioneOAll
                                          ]

export const NR_OGGETTI_BOTTONI = 50
export const OPZIONI_GRAFICI_PIEZOMETRI = [
                                             {
                                               Id : 'S',
                                               Descrizione : 'Standard'
                                             },
                                             {
                                               Id : 'P',
                                               Descrizione : 'Con packer'
                                             }
                                          ]   

export const COLORE_SPAZIATORE_MODULI = 'rgb(128,128,128)'                     
export const COLORE_GRAFICO_FREQUENZE = '#F18B53'                     

export const COLORE_GRAFICI_VERTICALI = {
                                          Griglia : '#949598',
                                          Grafico : '#57585a',
                                          Markup  : '#57585a',
                                          Sfondo  : 'white'
                                        }

export const TIPI_UDM_X = {
                            Giorni : 0,
                            Ore    : 1,
                            Minuti : 2
                          }

export const INTERVALLI_DI_TEMPO = {
                                      VentiquattroOre : 1000* 60 * 60 * 24,
                                      UnaSettimana    : 1000* 60 * 60 * 24 * 7,
                                      UnMese          : 1000* 60 * 60 * 24 * 30
                                    }

export const TZGraphLabelType = {
                                  lblInteger   : 0,
                                  lblDecimi    : 1,
                                  lblCentesimi : 2,
                                  lblMillesimi : 3
                                }

export const COLORI_ALLARME_CRONOLOGIA_ACC =  {
                                                Livello0 : '#008000',
                                                Livello1 : '#0000FF',
                                                Livello2 : '#FFA500',
                                                Livello3 : '#FF0000'
                                              }
export const TIPI_GRAFICI_STAZIONE_METEO = {
                                              Spostamenti          : 'S',
                                              Vento                : 'V',
                                              TemperaturaAria      : 'A',
                                              CumulativoPioggia    : 'C',
                                              GiornalieroPioggia   : 'G',
                                              PrecipitazioneOraria : 'P',
                                              DieciMinutiPioggia   : 'D',
                                              Falda                : 'F',
                                              TemperaturaSuolo     : 'T',
                                           }

export const POSIZIONI_TEXT_PLACEHOLDER = {
                                            Sopra    : 'T',
                                            Sotto    : 'B',
                                            Destra   : 'R',
                                            Sinistra : 'L'
                                          }

export const COLORI_SOGLIE_ALLARMI = {
                                       Blu     : '#0000FF',
                                       Giallo  : '#FFD700',
                                       Arancio : '#FF8C00',
                                       Rosso   : '#FF0000'
                                     }

export const SPESSORE_LINEE_SOGLIE_ALLARMI = {
                                               Spessore : 1
                                             }

export const DEFAULT_SOGLIE_EV_ACC = {
                                       SMS1        : { Tipologia: 'S', Y: 10, Colore: '#0000FF', Visibile: false, Attiva: true },
                                       SMS2        : { Tipologia: 'T', Y: 10, Colore: '#00AA00', Visibile: false, Attiva: true },
                                       SMS3        : { Tipologia: 'U', Y: 10, Colore: '#808080', Visibile: false, Attiva: true },
                                       SMS4        : { Tipologia: 'V', Y: 10, Colore: '#000000', Visibile: false, Attiva: true },
                                       Rilevamento : { Tipologia: 'R', Y: 10, Colore: '#00CC00', Visibile: false, Attiva: true },
                                       Allarme     : { Tipologia: 'A', Y: 10, Colore: '#FF0000', Visibile: false, Attiva: true }
                                     }

export const SOGLIE_EV_ACC = {
                               S : 'SMS1',
                               T : 'SMS2',
                               U : 'SMS3',
                               V : 'SMS4',
                               R : 'Rilevamento',
                               A : 'Allarme'
                             }

export const DIM_PLACEHOLDER = 30

export class TInfoGraficiStorici
{
  IdSito                = -1
  IdCatena              = -1
  TipoGrafico           = -1
  ListaModuli           = []
  FiltroDallaData       = new Date()
  FiltroAllaData        = new Date()
  FiltroDallaOra        = 0
  FiltroAllaOra         = 23
  VisualizzaMarkup      = false
  VisualizzaPluviometro = false
  VisualizzaAnemometro  = false
  VisualizzaTermometro  = false
  VisualizzaSpostamento = true
  InterpMinimiQuadrati  = false
  OrientamentoAsse      = 0
  PeriodoMedia          = 0
  AllineamentoIncl      = new Date()
  AllineamentoTemp      = new Date()
  AllineamentoDef       = new Date()
  ProfonditaStart       = -999
  ProfonditaEnd         = 999
  ListaFalde            = []
  ListaTuttiModuli      = []
  UrlRitornoAllaCatena  = ''

  constructor(IdSito, IdCatena, Descrizione, TipoGrafico, ListaModuli, FiltroDallaData, FiltroAllaData, FiltroDallaOra, FiltroAllaOra,
              VisualizzaMarkup     = false,
              InterpMinimiQuadrati = false, 
              OrientamentoAsse = 0, 
              PeriodoMedia = 0, 
              AllineamentoIncl = null,
              AllineamentoTemp = null, 
              AllineamentoDef = null,
              ProfonditaStart = -999,
              ProfonditaEnd = 999)
  {
    this.IdSito               = IdSito
    this.IdCatena             = IdCatena
    this.Descrizione          = Descrizione
    this.TipoGrafico          = TipoGrafico
    this.ListaModuli          = ListaModuli
    this.FiltroDallaData      = FiltroDallaData
    this.FiltroAllaData       = FiltroAllaData
    this.FiltroDallaOra       = FiltroDallaOra
    this.FiltroAllaOra        = FiltroAllaOra
    this.VisualizzaMarkup     = VisualizzaMarkup
    this.InterpMinimiQuadrati = InterpMinimiQuadrati
    this.OrientamentoAsse     = OrientamentoAsse
    this.PeriodoMedia         = PeriodoMedia
    this.AllineamentoIncl     = AllineamentoIncl
    this.AllineamentoTemp     = AllineamentoTemp
    this.AllineamentoDef      = AllineamentoDef
    this.ProfonditaStart      = ProfonditaStart
    this.ProfonditaEnd        = ProfonditaEnd
  }
}

class TSystemInformation
{
  Configurazione            = {}
  TipiMarkup                = []
  MenuTrigger               =  {
                                 AggiornaMenu                          : 0,
                                 StampaXLSX                            : 0,
                                 TriggerAdattaGrafici                  : 0,
                                 TriggerEsportaPDF                     : 0,
                                 TriggerMassimizza                     : 0,
                                 TriggerDifferenziale                  : 0,
                                 ApriPopupStorici                      : 0,
                                 ApriPopupStazioneMeteo                : 0,
                                 ApriPopupTensioneAssorbimento         : 0,
                                 ApriPopupAllineamentoAsseX            : 0,
                                 ApriPopupAllineamentoAsseInclinometri : 0,
                                 ApriPopupAllineamentoAssePiezometri   : 0,
                                 ApriPopupAllineamentoAsseDeformazioni : 0,
                                 ApriPopupAllineamentoAsseY            : 0,
                                 ApriPopupAllineamentoAsseTemp         : 0,
                                 ApriPopupModulazioneGrafici           : 0,
                                 ApriPopupMediaAritmetica              : 0,
                                 ApriPopupCambiaScale                  : 0,
                                 ApriPopupExportXLSXCampioniRilevati   : 0,
                                 ApriPopupExportXLSXSpostamenti        : 0,
                                 ApriPopupAllarmi                      : 0,
                                 ApriPopupImpostaAllarmi               : 0,
                                 
                                 TriggerMostraNascondiAllarmi          : 0,
                                 TriggerMostraGrafici                  : 0,
                                 TriggerAggiungiAbbinato               : 0,
                                 TriggerAllineaPolari                  : 0,
                                 TriggerMenuCatene                     : 0,
                                 TriggerAbilitaSpostamento             : 0,
                                 TriggerMostraSoglieRilevamento        : 0,
                                 TriggerNascondiSoglieRilevamento      : 0,

                                 ApriPopupScalaX                       : 0,
                                 ApriPopupScalaY                       : 0,
                                 ApriPopupColoreAmpiezzaX              : 0,
                                 ApriPopupColoreAmpiezzaY              : 0,
                                 ApriPopupColoreAmpiezzaZ              : 0,
                                 ApriPopupColoreFrequenza              : 0,
                                 ApriPopupAggiungiRighello             : 0,
                                 ApriPopupEliminaRighello              : 0,

                                 ApriPopupScalaGraphX                  : 0,
                                 ApriPopupScalaGraphY                  : 0,
                                 ApriPopupScalaGraphZ                  : 0,
                               }
  TipoPopupAperto           = -1
  OggettoInfoGraficiStorici = {}
  StazioneMeteo             = false;
  ListaLingue               = []

  GetInitConfig(OnEndFunction)
  {
    var Self = this

    // Prefer environment variables (set via Vue CLI: VUE_APP_*)
    // Direttamente - Vue CLI farà la sostituzione a build time
    var EnvUrlServer = process.env.VUE_APP_URL_SERVER || null
    var EnvUrlWebapp = process.env.VUE_APP_URL_WEBAPP || null
    var EnvDevMode   = process.env.VUE_APP_DEVELOPER_MODE === 'true' ? true : null
    
    Self.DeveloperMode = (EnvDevMode !== null) ? EnvDevMode : false

    axios.get('DMSEWConfiguration.json').then(function(Answer)
    {
      Self.Configurazione = Answer.data
      Self.Configurazione.URL_SERVER = EnvUrlServer
      Self.Configurazione.URL_WEBAPP = EnvUrlWebapp
      OnEndFunction(Self.Configurazione.URL_SERVER);
    })
    .catch(function(Error)
    {
      console.error(Error)
      OnEndFunction("");
    })

    axios.get('Simboli.json').then(function(Answer)
    {
      Self.TipiMarkup = Answer.data
    })
    .catch(function(Error)
    {
      console.erorr(Error)
    })
  }

  GetUserInformation(OnSuccess,OnError)
  {
     var self = this;
     this.AdvQuery.GetSQL("TutteLeConfigurazioni",{},
                          function(Results)
                          {
                            let ArrayInfo = self.AdvQuery.FindResults(Results,"UserInformation");
                            if(ArrayInfo != undefined && ArrayInfo.length > 0)
                            {
                               self.UserInformation = {                                    
                                                         UserName              : ArrayInfo[0].USERNAME,
                                                         Ruolo                 : ArrayInfo[0].ROLE,
                                                         PrimoAccesso          : ArrayInfo[0].PRIMO_ACCESSO,
                                                         Email                 : ArrayInfo[0].EMAIL,
                                                         RagioneSociale        : ArrayInfo[0].RAGIONE_SOCIALE,
                                                         Immagine              : ArrayInfo[0].IMMAGINE,
                                                         SensibilitaScroll     : ArrayInfo[0].SENSIBILITA_SCROLL,
                                                         FusoOrario            : ArrayInfo[0].FUSO_ORARIO,
                                                         AutorefreshDati       : ArrayInfo[0].TEMPO_AUTOREFRESH_DATI,
                                                         Lingua                : ArrayInfo[0].LINGUA,
                                                       };
                               self.GetConfigurazioni(OnSuccess)
                            }
                            else OnError("Impossibile ottenere le informazione dell'utente");
                          },
                          function(HTTPError,SubHTTPError)
                          {
                            OnError(HTTPError,SubHTTPError);
                          });
    
  }

  GetConfigurazioni(OnSuccess = undefined)
  {
    var self = this;
    this.AdvQuery.GetSQL("TutteLeConfigurazioni",{},
                         function(Results)
                         {
                            self.Configurazioni = {
                                                    Province                 : self.AdvQuery.FindResults(Results,"Province"),
                                                    Nazioni                  : self.AdvQuery.FindResults(Results,"Nazioni"),
                                                    Utenti                   : self.AdvQuery.FindResults(Results,"Utenti"),
                                                    Siti                     : self.AdvQuery.FindResults(Results,"Siti")
                                                  }
                            self.Configurazioni.Siti.forEach(element => {element.CHIAVE = parseInt(element.CHIAVE)});
                            self.Configurazioni.StatoItaliano = self.Configurazioni.Nazioni.find(function(Nazione)
                            {
                                return Nazione.SIGLA == 'IT'
                            });
                            if(self.Configurazioni.StatoItaliano != undefined)
                                self.Configurazioni.StatoItaliano = self.Configurazioni.StatoItaliano.CHIAVE;
                            else self.Configurazioni.StatoItaliano = -1;
                            if (OnSuccess != undefined)
                              OnSuccess()
                         },
                         function(HTTPError,SubHTTPError)
                         {
                          SystemInformation.HandleError(HTTPError,SubHTTPError);
                         },
                         'SelectConfigurazioni');
  }

  GetListaLingue()
  {
    for(let i = 0; i < window.TRADUZIONI_LINGUE.length; i++)
    {
      let Oggetto = {}
      Oggetto.Chiave = window.TRADUZIONI_LINGUE[i].Chiave
      Oggetto.Lingua = window.TRADUZIONI_LINGUE[i].Lingua
      this.ListaLingue.push(Oggetto)
    }  
  }

  CaricaCSV() 
  {
    fetch('./CapricornFiles/AssignTokenCapricorn.csv')
      .then(response => response.text())
      .then(TestoCSV => this.ElaboraCSV(TestoCSV))
      .catch(err => console.error('Errore nel caricamento del file CSV:', err));
  }

  ElaboraCSV(TestoCSV) 
  {
    var Righe   = TestoCSV.trim().split('\n');
    var Sezioni = {};
  
    for (let i = 1; i < Righe.length; i++) 
    {
      let Riga = Righe[i].split('\t');
      let RowObject = {
                        SEZIONE : Riga[0],
                        TOKEN   : Riga[1],
                        VALORE  : Riga[2]
                      };
  
      if (!Sezioni[RowObject.SEZIONE]) 
      {
        Sezioni[RowObject.SEZIONE] = [];
      }
  
      Sezioni[RowObject.SEZIONE].push({
                                        Token: RowObject.TOKEN,
                                        ValoreSuggerito: RowObject.VALORE
                                      });
    }
  
    var ResultArray = Object.keys(Sezioni).map(CurrentSezione => ({
                                                              Sezione: CurrentSezione,
                                                              Traduzioni: Sezioni[CurrentSezione]
                                                            }));

    for(let i = 0; i < window.TRADUZIONI_LINGUE.length; i++)
    {
      window.TRADUZIONI_LINGUE[i].Sezioni = ResultArray
    }
  }

  Init(OnEndFunction)
  {
    var self = this;
    if(window.TRADUZIONI_LINGUE != null)
      this.GetListaLingue()
    this.GetInitConfig(function(UrlServer)
    {
      if(self.DeveloperMode && window.TRADUZIONI_LINGUE != null)
        self.CaricaCSV() 
      self.AdvQuery.UrlServer = UrlServer;
      self.AdvQuerySiti.UrlServer = UrlServer
      let Token       = localStorage.getItem(LOCALSTORAGE.TokenRememberMe);
      if(Token != null)
      {
         self.AdvQuery.LoginWithToken(Token,
         function()
         {
            SystemInformation.GetUserInformation(function()
            {
              OnEndFunction();
            },
            function(HTTPError,SubHTTPError)
            {
              SystemInformation.HandleError(HTTPError,SubHTTPError);
              OnEndFunction();
            });
         },
         function()
         {
            window.location.assign(self.Configurazione.URL_WEBAPP)
            OnEndFunction()
         });
      }
      else
      {
        window.location.assign(self.Configurazione.URL_WEBAPP)
        OnEndFunction();
      }

    });
  }

  GetBlobSVGMarkup(NomeMarkup, Colore, MarkupWidth)
  {
    // let SVGMarkup = (this.TipiMarkup.find(element => element.Nome == NomeMarkup)).File
    let SVGMarkup = (this.TipiMarkup.find(element => element.Nome == 'CerchioPieno')).File
    SVGMarkup = SVGMarkup.replace('FILLCOLOR', Colore)
    SVGMarkup = SVGMarkup.replaceAll('DIMENSIONE', MarkupWidth + 'px')
    return 'data:image/svg+xml;base64,' + btoa(SVGMarkup)
  }
    
  ConvertDigitToLabelType(Digit)
  {
    switch(Digit)
    {
      case 0  : return TZGraphLabelType.lblInteger;
      case 1  : return TZGraphLabelType.lblDecimi;
      case 2  : return TZGraphLabelType.lblCentesimi;
      default : return TZGraphLabelType.lblMillesimi;
    }
  }

  GetPorzioniDiGiorni(DallaData, AllaData)
  {
    let Result = []
    let DallaDataTimeStamp = null
    let AllaDataTimeStamp  = null

    if(typeof DallaData.getMonth === 'function')
      DallaDataTimeStamp = DallaData.valueOf()
    else DallaDataTimeStamp = new Date(DallaData).valueOf()

    if(typeof AllaData.getMonth === 'function')
      AllaDataTimeStamp = AllaData.valueOf()
    else AllaDataTimeStamp = new Date(AllaData).valueOf()

    if(DallaDataTimeStamp < AllaDataTimeStamp)
    {
      let InizioData = DallaDataTimeStamp
      
      if(InizioData + NUMERO_GIORNI_DIVISIONE_CHIAMATA_DATI_STORICI < AllaDataTimeStamp)
      {
        while (InizioData + NUMERO_GIORNI_DIVISIONE_CHIAMATA_DATI_STORICI < AllaDataTimeStamp) 
        {
          let ObjData = {}
          ObjData.DallaData = InizioData
          ObjData.AllaData  = InizioData + NUMERO_GIORNI_DIVISIONE_CHIAMATA_DATI_STORICI

          Result.push(ObjData)
          
          InizioData = InizioData + NUMERO_GIORNI_DIVISIONE_CHIAMATA_DATI_STORICI
        }

        let ObjectData = {}
        ObjectData.DallaData = InizioData
        ObjectData.AllaData  = AllaDataTimeStamp
        Result.push(ObjectData)
      }
      else 
      {
        let ObjData    = {}
        ObjData.DallaData = DallaDataTimeStamp
        ObjData.AllaData  = AllaDataTimeStamp
        Result.push(ObjData)
      }
    }

    return Result
  }

  constructor()
  {
    this.AdvQuery = new TAdvQuery('');
    this.AdvQuerySiti = new TAdvQuery('')
    this.AdvQuerySiti.PHPConnection = 'CateneConnection.php'
    this.UserInformation = {};
    this.Configurazioni = {};
  }

  HandleError(Riga1,Riga2,Response)
  {
     if(Response == TAdvQueryErrors.HTTP_ERROR_NOT_LOGGED)
        this.Router.push("/");
     else alert(Riga1 + "\n" + Riga2);
  }
}

Number.prototype.BetweenTo = function(a, b)
{
  return this >= a && this <= b
} 

export class TTools
{
  static AdattaScaleGrafici(VettoreGrafici, MaxAsseX, MaxAsseY, Differenziale, MinProfondita, MaxProfondita, MinTemperatura, MaxTemperatura, MinDeformazione, MaxDeformazione, Adatta = true)
  {
    let ObjResult   = {
                        Polare : {}, 
                        Direzionale : {}, 
                        Totale : {}, 
                        Azimuth : {}, 
                        Temperatura : {}, 
                        Deformazione : {}, 
                        Pressione : {}, 
                        DeformazioneOAll : {}, 
                        ProfLong : {}, 
                        ProfLongAllineato : {} 
                      }
    let Larghezza   = (MaxAsseX > MaxAsseY ? MaxAsseX : MaxAsseY) * 2
    if (!(MinProfondita != undefined && MaxProfondita != undefined))
    {
      MinProfondita = 0
      MaxProfondita = 0
    }

    if(!(MinTemperatura != undefined && MaxTemperatura != undefined))
    {
      MinTemperatura = 0
      MaxTemperatura = 20
    }

    if(!(MinDeformazione != undefined && MaxDeformazione != undefined) || (MinDeformazione == 0 && MaxDeformazione == 0))
    {
      MinDeformazione = -1
      MaxDeformazione = 1
    }

    let AddToPolar = 2

    if(Larghezza < 10)
    {
      Larghezza  = 10
      AddToPolar = 0
    }

    if(Adatta)
    {
      if(!Differenziale)   
        Larghezza = TZMathFunct.GetMultiplo(Larghezza, 40, 'Eccesso')
      else
        Larghezza = TZMathFunct.GetMultiplo(Larghezza, 20, 'Eccesso')
      if (Larghezza == 0)
        Larghezza = 20
    }
    
    // Polari
    let Polare = ObjResult.Polare
    Polare.Max = Larghezza / 2 + AddToPolar
    Polare.Min = Polare.Max * (-1)
    Polare.Udm = Math.trunc(Larghezza / 8)

    let ArrayIntervalli = [
                            { Min : 0,   Max : 4,    Moltiplicatore : 2   },
                            { Min : 5,   Max : 20,   Moltiplicatore : 5   },
                            { Min : 21,  Max : 100,  Moltiplicatore : 20  },
                            { Min : 101, Max : 500,  Moltiplicatore : 100 },
                            { Min : 501, Max : 1000, Moltiplicatore : 500 }
                          ]
    // Verticali
    let MaxX         = Larghezza / 2
    let MinX         = MaxX * (-1)
    let UdmX         = Larghezza / 5
    let Direzionale  = ObjResult.Direzionale
    let Totale       = ObjResult.Totale
    let Azimuth      = ObjResult.Azimuth
    let Temperatura  = ObjResult.Temperatura
    let Deformazione = ObjResult.Deformazione
    let Pressione    = ObjResult.Pressione

    Pressione.MaxX = MaxX
    Pressione.MinX = MinX

    Direzionale.MaxX = MaxX
    Direzionale.MinX = MinX

    Totale.MaxX = Larghezza
    Totale.MinX = 0

    Azimuth.MinX = 0
    Azimuth.MaxX = 360
    Azimuth.UdmX = 60

    Temperatura.MinX = MinTemperatura * 10
    Temperatura.MaxX = MaxTemperatura * 10

    this.SetRangeTemperatura(Temperatura)

    Deformazione.MinX = MinDeformazione
    Deformazione.MaxX = MaxDeformazione

    if(Deformazione.MinX != null && Deformazione.MaxX != null)
    {
      let RangeDeformazione = Deformazione.MaxX - Deformazione.MinX
      if (RangeDeformazione == 0)
      {
        Deformazione.MaxX = Deformazione.MinX + 10
        RangeDeformazione = 10
      }
      Deformazione.UdmX = TZMathFunct.GetMultiplo(RangeDeformazione / 10, 0.1, 'Eccesso')     
      
      if(Deformazione.UdmX < 0.1)
        Deformazione.UdmX = 0.1;
    }

    for(let i = 0; i < ArrayIntervalli.length; i++)
    {
      let Element = ArrayIntervalli[i] 
      
      if(UdmX.BetweenTo(Element.Min, Element.Max))
        UdmX = TZMathFunct.GetMultiplo(UdmX, Element.Moltiplicatore, 'Difetto')
      
      if(Polare.Udm.BetweenTo(Element.Min, Element.Max))
        Polare.Udm = TZMathFunct.GetMultiplo(Polare.Udm, Element.Moltiplicatore, 'Difetto')
    }

    if(UdmX > 1000)
      UdmX = TZMathFunct.GetMultiplo(UdmX, 1000, 'Difetto')
    
    if(Polare.Udm > 1000)
      Polare.Udm = TZMathFunct.GetMultiplo(Polare.Udm, 1000, 'Difetto')
    
    if(UdmX == 0)
      UdmX = 1
    
    if(Polare.Udm == 0)
      Polare.Udm = 1

    Direzionale.UdmX  = UdmX
    Pressione.UdmX    = UdmX
    Totale.UdmX       = UdmX

    let MinY          = MaxProfondita
    let MaxY          = MinProfondita
    let UdmY          = TTools.AdjustUdmAsProfondita(MinY, MaxY)

    Direzionale.MinY  = MinY
    Direzionale.MaxY  = MaxY
    Direzionale.UdmY  = UdmY
    
    Pressione.MinY    = MinY
    Pressione.MaxY    = MaxY
    Pressione.UdmY    = UdmY
    
    Deformazione.MinY = MinY
    Deformazione.MaxY = MaxY
    Deformazione.UdmY = UdmY
    
    Totale.MinY       = MinY
    Totale.MaxY       = MaxY
    Totale.UdmY       = UdmY
    
    Azimuth.MinY      = MinY
    Azimuth.MaxY      = MaxY
    Azimuth.UdmY      = UdmY
    
    Temperatura.MinY  = MinY
    Temperatura.MaxY  = MaxY
    Temperatura.UdmY  = UdmY

    for(let i = 0; i < VettoreGrafici.length; i++)
    {
      let Grafico = VettoreGrafici[i].DatiGrafici

      Grafico.Polare       = ObjResult.Polare
      Grafico.Direzione    = ObjResult.Direzionale
      Grafico.Pressione    = ObjResult.Pressione
      Grafico.Totale       = ObjResult.Totale
      Grafico.Azimuth      = ObjResult.Azimuth
      Grafico.Temperatura  = ObjResult.Temperatura
      Grafico.Deformazione = ObjResult.Deformazione
    }
  }

  static AdattaScaleOrizzontali(VettoreGrafici, MaxMinGraph, MaxMinGraphAllineato, MinTemperatura, MaxTemperatura, MinDeformazione, MaxDeformazione, MinDistanzaBuco, MaxDistanzaBuco)
  {
    let ObjResult = {TemperaturaO : {}, DeformazioneO : {}, DeformazioneOAll : {}, ProfLong : {}, ProfLongAllineato : {}}
    let Temperatura      = ObjResult.TemperaturaO
    let Deformazione     = ObjResult.DeformazioneO
    let DeformazioneOAll = ObjResult.DeformazioneOAll
    let ProfLong         = ObjResult.ProfLong
    let ProfLongA        = ObjResult.ProfLongAllineato
    
    let MinX = MinDistanzaBuco
    let MaxX = MaxDistanzaBuco
    let UdmX = TTools.AdjustUdmAsProfondita(MaxX, MinX)

    Temperatura.MinX  = MinX
    Temperatura.MaxX  = MaxX
    Temperatura.UdmX  = UdmX
    Deformazione.MinX = MinX
    Deformazione.MaxX = MaxX
    Deformazione.UdmX = UdmX    
    ProfLong.MinX     = MinX
    ProfLong.MaxX     = MaxX
    ProfLong.UdmX     = UdmX    
    ProfLongA.MinX    = MinX
    ProfLongA.MaxX    = MaxX
    ProfLongA.UdmX    = UdmX    
    DeformazioneOAll.MinX = MinX
    DeformazioneOAll.MaxX = MaxX
    DeformazioneOAll.UdmX = UdmX        

    if (!(MinTemperatura != undefined && MaxTemperatura != undefined))
    {
      MinTemperatura = 0
      MaxTemperatura = 20
    }
    if (!(MinDeformazione != undefined && MaxDeformazione != undefined) || (MinDeformazione == 0 && MaxDeformazione == 0))
    {
      MinDeformazione = -1
      MaxDeformazione = 1
    } 

    let Larghezza = TZMathFunct.GetMultiplo(Math.abs(MaxMinGraph), 40, 'Eccesso')
    if (Larghezza == 0)
      Larghezza = 40
    ProfLong.MaxY = Larghezza
    ProfLong.MinY = -1 * Larghezza
    ProfLong.UdmY = Larghezza / 3
    
    let ArrayIntervalli = 
    [
      {Min : 0, Max : 4, Moltiplicatore : 2},
      {Min : 5, Max : 20, Moltiplicatore : 5},
      {Min : 21, Max : 100, Moltiplicatore : 20},
      {Min : 101, Max : 500, Moltiplicatore : 100},
      {Min : 501, Max : 1000, Moltiplicatore : 500}
    ]
    
    for (let i = 0; i < ArrayIntervalli.length; i++)
    {
      let Element = ArrayIntervalli[i] 
      if (ProfLong.UdmY.BetweenTo(Element.Min, Element.Max))
        ProfLong.UdmY = TZMathFunct.GetMultiplo(ProfLong.UdmY, Element.Moltiplicatore, 'Eccesso')
    }    
    if (ProfLong.UdmY > 1000)
      ProfLong.UdmY = TZMathFunct.GetMultiplo(ProfLong.UdmY, 1000, 'Eccesso')

    // da rivedere
    // let Larghezza  = TZMathFunct.GetMultiplo(Math.abs(MaxMinGraph), 7000, 'Eccesso')
    // ProfLong.MaxY  = Larghezza
    // ProfLong.MinY  = ProfLong.MaxY * (-1)
    // ProfLong.UdmY  = Larghezza / 3  

    if(MaxMinGraphAllineato == 0)
    {
      ProfLongA.MaxY = ProfLong.MaxY
      ProfLongA.MinY = ProfLong.MinY
      ProfLongA.UdmY = ProfLong.UdmY
    }
    else
    {
      let LarghezzaA = TZMathFunct.GetMultiplo(Math.abs(MaxMinGraphAllineato), 0.5, 'Eccesso')
      if (LarghezzaA == 0)
        LarghezzaA = 0.5
      ProfLongA.MaxY = LarghezzaA
      ProfLongA.MinY = ProfLongA.MaxY * (-1)
      ProfLongA.UdmY = TZMathFunct.GetMultiplo(Math.abs(LarghezzaA / 3), 0.2, 'Eccesso')

      if (ProfLongA.UdmY < 0.1)
        ProfLongA.UdmY = 0.1;
    }

    Temperatura.MinY = MinTemperatura * 10
    Temperatura.MaxY = MaxTemperatura * 10
    
    this.SetRangeTemperaturaYAxis(Temperatura)
    ProfLong.MinAltY = Temperatura.MinY
    ProfLong.MaxAltY = Temperatura.MaxY
    ProfLong.UdmAltY = Temperatura.UdmY
    Deformazione.MinAltY = Temperatura.MinY
    Deformazione.MaxAltY = Temperatura.MaxY
    Deformazione.UdmAltY = Temperatura.UdmY
    DeformazioneOAll.MinAltY = Temperatura.MinY
    DeformazioneOAll.MaxAltY = Temperatura.MaxY
    DeformazioneOAll.UdmAltY = Temperatura.UdmY

    // per questo serve un altro calcolo
    ProfLongA.MinAltY = Temperatura.MinY
    ProfLongA.MaxAltY = Temperatura.MaxY
    ProfLongA.UdmAltY = Temperatura.UdmY

    let LarghezzaDeformazione = TZMathFunct.GetMultiplo(Math.max(Math.abs(MinDeformazione), Math.abs(MaxDeformazione)), 2, 'Eccesso') //10
    if (LarghezzaDeformazione == 0)
      LarghezzaDeformazione = 2
    Deformazione.MaxY = LarghezzaDeformazione
    Deformazione.MinY = LarghezzaDeformazione * (-1)
    
    let ArrayIntervalliDef = 
    [
      {Min : 0, Max : 4, Moltiplicatore : 2},
      {Min : 5, Max : 20, Moltiplicatore : 5},
      {Min : 21, Max : 50, Moltiplicatore : 10},
      {Min : 51, Max : 100, Moltiplicatore : 20},
      {Min : 101, Max : 500, Moltiplicatore : 100},
      {Min : 501, Max : 1000, Moltiplicatore : 500}
    ]

    if (Deformazione.MinY != null && Deformazione.MaxY != null)
    {
      Deformazione.UdmY = LarghezzaDeformazione / 3   
      if(Deformazione.UdmY >= 1)
      {
        for (let i = 0; i < ArrayIntervalliDef.length; i++)
        {
          let Element = ArrayIntervalliDef[i] 
          if (Deformazione.UdmY.BetweenTo(Element.Min, Element.Max))
            Deformazione.UdmY = TZMathFunct.GetMultiplo(Deformazione.UdmY, Element.Moltiplicatore, 'Difetto')
        }    
        if (Deformazione.UdmY > 1000)
          Deformazione.UdmY = TZMathFunct.GetMultiplo(Deformazione.UdmY, 1000, 'Difetto')
      }
      
      // Deformazione.UdmY = TZMathFunct.GetMultiplo(LarghezzaDeformazione, 10, 'Difetto')
      // Deformazione.UdmY = TZMathFunct.GetMultiplo(LarghezzaDeformazione, 1, 'Difetto')
      // if (Deformazione.UdmY < 0.1)
      //   Deformazione.UdmY = 0.1;
    }
    
    if(MaxMinGraphAllineato == 0)
    {
      DeformazioneOAll.MaxY = ProfLong.MaxY
      DeformazioneOAll.MinY = ProfLong.MinY
      DeformazioneOAll.UdmY = ProfLong.UdmY
    }
    else
    {
      let LarghezzaA = TZMathFunct.GetMultiplo(Math.abs(MaxMinGraphAllineato), 0.5, 'Eccesso')
      if (LarghezzaA == 0)
        LarghezzaA = 0.5
      DeformazioneOAll.MaxY = LarghezzaA
      DeformazioneOAll.MinY = DeformazioneOAll.MaxY * (-1)
      DeformazioneOAll.UdmY = TZMathFunct.GetMultiplo(Math.abs(LarghezzaA / 3), 0.2, 'Eccesso')

      if (DeformazioneOAll.UdmY < 0.1)
        DeformazioneOAll.UdmY = 0.1;
    }
    
    for (let i = 0; i < VettoreGrafici.length; i++)
    {
      let Grafico = VettoreGrafici[i].DatiGrafici
      Grafico.DatiGraficoOrizzontale = {}
      Grafico.DatiGraficoOrizzontale.MaxMin           = MaxMinGraph
      Grafico.DatiGraficoOrizzontale.MaxMinGraphA     = MaxMinGraphAllineato
      Grafico.DatiGraficoOrizzontale.Temperatura      = ObjResult.TemperaturaO
      Grafico.DatiGraficoOrizzontale.ProfLong         = ObjResult.ProfLong
      Grafico.DatiGraficoOrizzontale.ProfLongA        = ObjResult.ProfLongAllineato
      Grafico.DatiGraficoOrizzontale.Deformazione     = ObjResult.DeformazioneO
      Grafico.DatiGraficoOrizzontale.DeformazioneOAll = ObjResult.DeformazioneOAll   
    }
  }

  // static AdattaAsseYAllineatiOrizzontali(VettoreGrafici, MaxMinGraphAllineato)
  // {
  //   let ObjResult = {ProfLongAllineato : {}}
  //   for (let i = 0; i < VettoreGrafici.length; i++)
  //   {
  //     let Grafico = VettoreGrafici[i].DatiGrafici
  //     Grafico.MaxMin       = MaxMinGraph
  //     Grafico.MaxMinGraphA = MaxMinGraphAllineato
  //     Grafico.Temperatura  = ObjResult.Temperatura
  //     Grafico.ProfLong     = ObjResult.ProfLong
  //     Grafico.ProfLongA    = ObjResult.ProfLongAllineato
  //     Grafico.Deformazione = ObjResult.Deformazione
  //   }
  // }

  static SetRangeTemperatura(ObjTemperatura)
  {
    let SetRangeIfPossible = function(Min, Max, Udm)
    {
      if (ObjTemperatura.MinX >= Min && ObjTemperatura.MaxX <= Max)
      {
        ObjTemperatura.MinX = Min
        ObjTemperatura.MaxX = Max
        ObjTemperatura.UdmX = Udm
        return true
      }
      return false
    }

    if (!SetRangeIfPossible(0, 25, 5))
      if (!SetRangeIfPossible(0, 40, 5))
        if (!SetRangeIfPossible(10, 15, 5))
        {
          ObjTemperatura.MaxX = TZMathFunct.GetMultiplo(ObjTemperatura.MaxX, 5, 'Eccesso')
          ObjTemperatura.MinX = TZMathFunct.GetMultiplo(ObjTemperatura.MinX, 5, 'Difetto')
          ObjTemperatura.UdmX = (ObjTemperatura.MaxX - ObjTemperatura.MinX) / 6
          if (ObjTemperatura.UdmX > 5)
            ObjTemperatura.UdmX = TZMathFunct.GetMultiplo(ObjTemperatura.UdmX, 5, 'Eccesso')
          else
          {
            if (ObjTemperatura.UdmX >= 2)
              ObjTemperatura.UdmX = 2
            else
            {
              if (ObjTemperatura.UdmX >= 1)
                ObjTemperatura.UdmX = 1
              else
                ObjTemperatura.UdmX = 0.5
            }
          }
        }
  }

    static SetRangeTemperaturaYAxis(ObjTemperatura)
  {
    
    let SetRangeIfPossible = function(Min, Max, Udm)
    {
      if (ObjTemperatura.MinY >= Min && ObjTemperatura.MaxY <= Max)
      {
        ObjTemperatura.MinY = Min
        ObjTemperatura.MaxY = Max
        ObjTemperatura.UdmY = Udm
        return true
      }
      return false
    }

    if (!SetRangeIfPossible(0, 25, 5))
      if (!SetRangeIfPossible(0, 40, 5))
        if (!SetRangeIfPossible(10, 15, 5))
        {
          ObjTemperatura.MaxY = TZMathFunct.GetMultiplo(ObjTemperatura.MaxY, 5, 'Eccesso')
          ObjTemperatura.MinY = TZMathFunct.GetMultiplo(ObjTemperatura.MinY, 5, 'Difetto')
          ObjTemperatura.UdmY = (ObjTemperatura.MaxY - ObjTemperatura.MinY) / 6
          
          if (ObjTemperatura.UdmY > 5)
            ObjTemperatura.UdmY = TZMathFunct.GetMultiplo(ObjTemperatura.UdmY, 5, 'Eccesso')
          else
          {
            if (ObjTemperatura.UdmY >= 2)
              ObjTemperatura.UdmY = 2
            else
            {
              if (ObjTemperatura.UdmY >= 1)
                ObjTemperatura.UdmY = 1
              else
                ObjTemperatura.UdmY = 0.5
            }
          }
        }
  }

  static AdjustUdmAsProfondita(Min, Max)
  {
    let Multiplo = 1
    let Result = (Min - Max) / 30
    if (Min > 10)
      Multiplo = 2
    if (Min >= 30)
      Multiplo = 5
    if (Min >= 150)
      Multiplo = 10
    Result = TZMathFunct.GetMultiplo(Result, Multiplo, 'Eccesso')
    if (Result == 0)
      return Multiplo
    return Result
  }
}

export class TCfgCatena
{
  constructor(ObjCatena)
  {
    this.Generale    = ObjCatena.DatiCatena
    this.Altro       = ObjCatena.AltreInfo
    this.Moduli      = ObjCatena.Moduli
    this.DatiGrafici = ObjCatena.DatiGrafici
  }

  GetCfgModuloByKey(Modulo)
  {
    return this.Moduli.find(element => element.MODULO == Modulo)
  }
}

export var SystemInformation = new TSystemInformation();
